import { useEffect } from 'react';
import { FallbackProps } from 'react-error-boundary';

import { Header } from '@src/components/header';
import { useDynatrace } from '@src/hooks/use-dynatrace.hook';
import { PhoneNumberLink } from '@src/components/phone-number-link';
import { chewyCarePlusSupport } from '@src/constants/phone-numbers';

import '@src/components/error-fallback/error-fallback-page.scss';

/**
 * @deprecated This will be removed as part of error page refactors.
 * Please use src/main/js/components/error instead.
 */
export const ErrorFallbackPage = ({ error }: Partial<FallbackProps>) => {
  const { reportError, addAction } = useDynatrace();
  useEffect(() => {
    reportError(error);
    addAction('Viewing Global Error Page Fallback');
  }, [error, reportError, addAction]);

  return (
    <div id="hc-pet-insurance__error">
      <Header hideBackButton hideCallBtn />
      <div className="hc-pet-insurance__container">
        <div className="hc-pet-insurance__content">
          <div className="hc-pet-insurance__content">
            <div id="hc-pet-insurance__media-container">
              <svg
                aria-hidden="true"
                focusable="false"
                role="img"
                viewBox="0 0 100 100"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="50" cy="50" r="46" />
              </svg>

              <img
                alt=""
                aria-hidden="true"
                src="/pet-insurance/img/dachshund.png"
              />
            </div>

            <main aria-label="content">
              <h1>Oops! Something went wrong.</h1>
              <p>
                If the error persists after refreshing the page, please call{' '}
                <PhoneNumberLink contact={chewyCarePlusSupport} /> to speak to a
                representative.
              </p>
            </main>
          </div>
        </div>
      </div>
    </div>
  );
};
